const BASE_URL = 'https://portfolio.notkoneko.space';

export const personSchema = {
  '@context': 'https://schema.org',
  '@type': 'Person',
  '@id': `${BASE_URL}/#person`,
  name: 'NotKoneko',
  alternateName: ['Koneko', 'NottKoneko', 'Koneko Dev', 'Koneko Research'],
  url: BASE_URL,
  image: `${BASE_URL}/lyrika-avatar.webp`,
  jobTitle: 'Software Engineer & Cognitive Systems Researcher',
  description: 'Software engineer and researcher architecting predictive data models, specialized API engines, and native mobile applications at the intersection of human cognition and machine intelligence.',
  alumniOf: {
    '@type': 'CollegeOrUniversity',
    name: 'Arizona State University',
    sameAs: 'https://www.asu.edu'
  },
  knowsAbout: [
    'Computer Science',
    'Cognitive Neuroscience',
    'Psychology',
    'Swift 6',
    'SwiftUI',
    'Apple HealthKit',
    'Discord Bot Architecture',
    'Machine Learning',
    'Bioacoustics & Soundscape AI',
    'React',
    'Node.js',
    'State Space Models',
    'Predictive Modeling'
  ],
  sameAs: [
    'https://github.com/NottKoneko',
    'https://x.com/NottKoneko',
    'https://portfolio.notkoneko.space',
    'https://lyrika.notkoneko.space',
    'https://tamed.pages.dev',
    'https://templates.notkoneko.space'
  ]
};

export const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  '@id': `${BASE_URL}/#website`,
  url: BASE_URL,
  name: 'NotKoneko Portfolio',
  alternateName: ['Koneko Portfolio', 'NotKoneko Systems Directory', 'Koneko Research Space'],
  description: 'Architecting predictive data models, specialized API engines, and native mobile applications at the intersection of human cognition and machine intelligence.',
  publisher: {
    '@id': `${BASE_URL}/#person`
  },
  inLanguage: 'en-US'
};

export const getBreadcrumbSchema = (crumbs) => ({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: crumbs.map((crumb, index) => ({
    '@type': 'ListItem',
    position: index + 1,
    name: crumb.name,
    item: crumb.url.startsWith('http') ? crumb.url : `${BASE_URL}${crumb.url}`
  }))
});

export const getSoftwareAppSchema = ({
  name,
  description,
  applicationCategory,
  operatingSystem = 'Cross-platform',
  url,
  codeRepository,
  screenshot,
  featureList = []
}) => ({
  '@context': 'https://schema.org',
  '@type': 'SoftwareApplication',
  name,
  alternateName: [`${name} by Koneko`, `${name} by NotKoneko`],
  description,
  applicationCategory,
  operatingSystem,
  url: url ? (url.startsWith('http') ? url : `${BASE_URL}${url}`) : BASE_URL,
  author: {
    '@id': `${BASE_URL}/#person`
  },
  ...(codeRepository && { codeRepository }),
  ...(screenshot && { screenshot: screenshot.startsWith('http') ? screenshot : `${BASE_URL}${screenshot}` }),
  ...(featureList.length > 0 && { featureList: featureList.join(', ') }),
  offers: {
    '@type': 'Offer',
    price: '0.00',
    priceCurrency: 'USD',
    availability: 'https://schema.org/OnlineOnly'
  }
});

export const getScholarlyArticleSchema = ({
  headline,
  description,
  datePublished,
  url,
  pdfUrl,
  keywords = []
}) => ({
  '@context': 'https://schema.org',
  '@type': 'ScholarlyArticle',
  headline,
  description,
  author: {
    '@id': `${BASE_URL}/#person`
  },
  publisher: {
    '@id': `${BASE_URL}/#person`
  },
  datePublished,
  inLanguage: 'en-US',
  url: url.startsWith('http') ? url : `${BASE_URL}${url}`,
  ...(pdfUrl && {
    encoding: {
      '@type': 'MediaObject',
      contentUrl: pdfUrl.startsWith('http') ? pdfUrl : `${BASE_URL}${pdfUrl}`,
      encodingFormat: 'application/pdf'
    }
  }),
  keywords: keywords.join(', ')
});
